import { apiRequest } from "../../../shared/lib/api";

export type AsaasSettings = {
  environment: "sandbox" | "production";
  platformWalletId: string;
  splitEnabled: boolean;
  platformFeeType: "percent" | "fixed";
  platformFeeValue: number;
  updatedByUserId?: number | null;
  updatedAt?: string | null;
};

export type AsaasOrganizerSettings = {
  id: number;
  name: string;
  email: string;
  walletId: string;
  splitEnabled: boolean;
  updatedAt?: string | null;
};

export type MyAsaasWalletSettings = {
  walletId: string;
  splitEnabled: boolean;
  updatedAt?: string | null;
};

export type EventPaymentSettings = {
  eventId: string;
  paymentMode: "free" | "asaas_internal" | "external_link";
  amountMode: "individual" | "pair";
  amountCents: number;
  externalPaymentUrl?: string | null;
  registrationsOpen: boolean;
  currency?: string;
  updatedAt?: string | null;
};

export async function getAsaasSettings(token: string) {
  return apiRequest<AsaasSettings>("/api/admin/asaas/settings", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function updateAsaasSettings(
  token: string,
  payload: {
    environment: "sandbox" | "production";
    platformWalletId?: string;
    splitEnabled: boolean;
    platformFeeType: "percent" | "fixed";
    platformFeeValue: number;
  },
) {
  return apiRequest<{ ok: boolean }>("/api/admin/asaas/settings", {
    method: "PUT",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
}

export async function listAsaasOrganizerSettings(token: string) {
  return apiRequest<AsaasOrganizerSettings[]>("/api/admin/asaas/organizers", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function updateAsaasOrganizerSettings(
  token: string,
  organizerUserId: number,
  payload: { walletId: string; splitEnabled: boolean },
) {
  return apiRequest<{ ok: boolean }>(
    `/api/admin/asaas/organizers/${organizerUserId}`,
    {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    },
  );
}

export async function getMyAsaasWallet(token: string) {
  return apiRequest<MyAsaasWalletSettings>("/api/me/asaas/wallet", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function updateMyAsaasWallet(
  token: string,
  payload: { walletId: string; splitEnabled: boolean },
) {
  return apiRequest<{ ok: boolean }>("/api/me/asaas/wallet", {
    method: "PUT",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
}

export async function getEventPaymentSettings(
  token: string,
  eventId: string,
) {
  return apiRequest<EventPaymentSettings>(
    `/api/admin/events/${encodeURIComponent(eventId)}/payment-settings`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
}

export async function updateEventPaymentSettings(
  token: string,
  eventId: string,
  payload: {
    paymentMode?: "free" | "asaas_internal" | "external_link";
    amountMode?: "individual" | "pair";
    amountCents?: number;
    externalPaymentUrl?: string;
    registrationsOpen?: boolean;
    currency?: string;
  },
) {
  return apiRequest<{ ok: boolean }>(
    `/api/admin/events/${encodeURIComponent(eventId)}/payment-settings`,
    {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    },
  );
}
